export default "<mat-tab-group>\n  <mat-tab label=\"Today\"> Content 1 </mat-tab>\n  <mat-tab label=\"Notifications\"> Content 2 </mat-tab>\n</mat-tab-group>\n"